export default __webpack_public_path__ + "static/media/banner-v3.14786632.webp";